// extracted by mini-css-extract-plugin
export default {"none":"uhCh4FrZrP"};